import { FC } from 'react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import SunshineCard from 'components/_core/SunshineCard';
import { ExpenseClaimRequestRow } from 'features/Team/pages/Requests/components/TeamRequestsList/components/ExpenseClaimRequestRow';

import {
  isBankTransferRequest,
  isExpenseClaimRequest,
  isPaymentCardRequest,
  Request,
} from '../../hooks/useRequests';
import BankTransferRequestRow from './components/BankTransferRequestRow';
import PaymentCardRequestRow from './components/PaymentCardRequestRow';

interface TeamRequestsListProps {
  requests: Request[];
  selectedRequest: Request | undefined;
  onRequestClick: (teamMembersRequestId: string) => void;
}

const TeamRequestsList: FC<TeamRequestsListProps> = ({
  onRequestClick,
  requests,
  selectedRequest,
}) => {
  const { companyUserId } = useCompanyContext();

  return (
    <SunshineCard.Group>
      {requests.map((request) => {
        if (isExpenseClaimRequest(request)) {
          return (
            <ExpenseClaimRequestRow
              isActive={
                request.teamMembersRequestId ===
                selectedRequest?.teamMembersRequestId
              }
              key={request.teamMembersRequestId}
              onClick={() => onRequestClick(request.teamMembersRequestId)}
              request={request}
            />
          );
        }

        if (isBankTransferRequest(request)) {
          return (
            <BankTransferRequestRow
              isActive={
                request.teamMembersRequestId ===
                selectedRequest?.teamMembersRequestId
              }
              key={request.teamMembersRequestId}
              onClick={() => onRequestClick(request.teamMembersRequestId)}
              request={request}
            />
          );
        }
        if (isPaymentCardRequest(request)) {
          return (
            <PaymentCardRequestRow
              isActive={
                request.teamMembersRequestId ===
                selectedRequest?.teamMembersRequestId
              }
              isReviewer={request.reviewer?.companyUserId === companyUserId}
              key={request.teamMembersRequestId}
              onClick={() => onRequestClick(request.teamMembersRequestId)}
              request={request}
            />
          );
        }
        return null;
      })}
    </SunshineCard.Group>
  );
};

export default TeamRequestsList;
